/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { type PropsWithChildren } from 'react';
import { css, jsx } from '@compiled/react';
import { fg } from '@atlassian/jira-feature-gating';

export const ActionContainer = ({ children }: PropsWithChildren<{}>) => {
	return (
		<div
			data-testid="native-issue-table.common.ui.issue-cells.issue-summary.action-container"
			css={[fg('jira_list_merged_column_gate') ? containerStyles : containerStylesOld]}
		>
			{children}
		</div>
	);
};

const containerStyles = css({
	display: 'flex',
	flexGrow: 1,
	minHeight: '100%',
	'--open-button-display': 'none',
	'&:hover': {
		'--open-button-display': 'flex',
	},
	'&:focus-within': {
		'--open-button-display': 'flex',
	},
});

/**
 * @deprecated remove when jira_list_merged_column_gate is removed
 */
const containerStylesOld = css({
	display: 'flex',
	flexGrow: 1,
	minHeight: '100%',
	'--open-button-opacity': 0,
	'&:hover': {
		'--open-button-opacity': 1,
	},
	'&:focus-within': {
		'--open-button-opacity': 1,
	},
});
